import React, { useState, useEffect } from 'react';
import { initFacebookPixel } from '../facebookPixel';
import './Faq.css'; 

const faqs = [
  {
    question: 'What will be the coach-to-player ratio?',
    answer: 'For Swimming, the coach-to-player ratio will be 1:10.',
  },
  {
    question: 'When will the Summer Camp start and when will it end?',
    answer: 'The Machaxi Summer Camp will start on April 3, 2024, and will end on June 3, 2024.',
  },
  {
    question: 'What are the batches and time slots available for Swimming?',
    answer: `For Swimming, there are multiple batch time options, and there are 3 batches:

Batches:
- Batch 1: April 3 - April 22
- Batch 2: April 24 - May 13
- Batch 3: May 15 - June 3

Tentative Class Timings: 
8 AM - 9 AM, 9 AM - 10 AM, 10 AM - 11 AM, 3 PM - 4 PM, 4 PM - 5 PM, 5 PM - 6 PM

Apart from the Summer Camp, we have regular batches in the morning and evening.`,
  },
  {
    question: 'Are there any early bird offers?',
    answer: 'Yes, there are early bird discounts available until April 2nd! Please check our plans for the sport you want to enroll in.',
  },
  {
    question: 'What are the sports equipment and attire required?',
    answer: 'For Swimming, swim trunks/suits with a swimming cap are mandatory. Players may also need goggles for underwater training.',
  },
  {
    question: 'What if my Child already Knows Swimming?',
    answer: 'No, the Summer Camp is designed only for beginners. For children who already know swimming, we offer our renowned curriculum-based batches.',
  },
];



const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const handleExpand = (index) => {
    setExpandedIndex(index === expandedIndex ? null : index);
  };
  document.querySelectorAll('.faq-header-item').forEach(item => {
    item.addEventListener('click', () => {
      const answer = item.nextElementSibling;
  
      // Toggle the "open" class on the answer
      answer.classList.toggle('open');
    });
  });
  useEffect(() => {
    initFacebookPixel(); // Track page view when this page loads
  }, []);
  return (
    <div className="faq-container">
      <h2 className="faq-header">FAQ's</h2>
      <ul className="faq-list">
        {faqs.map((faq, index) => (
          <li key={index} className="faq-item">
            <div
              className="faq-header-item"
              onClick={() => handleExpand(index)}
            >
               <span className={`faq-toggle ${expandedIndex === index ? 'expanded' : ''}`}>
                {expandedIndex === index ? '▾' : '▸'}
              </span>
              <span className="faq-question">{faq.question}</span>
             
            </div>
            <div className={`faq-answer ${expandedIndex === index ? 'open' : ''}`}>
              <pre>{faq.answer}</pre>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FAQ;
